import { IAppConfig } from '../interface/IAppConfig';

export const AppConfigService = (baseName: string | null, dataApiAwsHost: string | null) => {
    const context = window.topContext;
    const siteConfig = context.config.getSiteConfig();
    const endpointConfig = context.config.getEndpointConfig();
    const apiAwsHost = endpointConfig.apiAwsHost;
    dataApiAwsHost = dataApiAwsHost || apiAwsHost;
    return {
        appName: 'onsa-content',
        baseName: baseName || '/',
        environment: siteConfig.environment, // Used by {apiGatewayBase}/v2/openapi/api/insurance-companies
        objectCacheUrl: apiAwsHost + '/objects',
        resourceBundleApiUrl: endpointConfig.resourceBundle,
        wso2ApiHost: endpointConfig.wso2host,
        wso2ApiUrl: dataApiAwsHost + '/proxy/v2/onlinesales-services/api',
        wso2OpenApiUrl: dataApiAwsHost + '/proxy/v2/openapi/onlinesales-services/api',
        insuranceCompaniesApiUrl: dataApiAwsHost + '/proxy/v2/openapi/api/insurance-companies',
        gtiServiceApiUrl: dataApiAwsHost + '/proxy/v2/gti-services',
        gteboksServiceUrl: dataApiAwsHost + '/proxy/v2/GTEboks/GTEboks',
        giftCardServiceUrl: dataApiAwsHost + '/proxy/v2/openapi/onlinesales-services/api/products/giftCard',
        customerMarkingServiceUrl: dataApiAwsHost + '/proxy/v2/onlinesales-services/api/customer/kundemarkering',
        bankValidationUrl: dataApiAwsHost + '/proxy/v2/openapi/automated-payment-service/payment/services/bankaccount'
    } as IAppConfig;
};
